import {RadioField} from '@/components/commons/radio-field/RadioField'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FormFieldBox} from '@/components/ui/form-atoms/FormAtoms'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {Label} from '@/components/ui/label/Label'
import {useTranslation} from '@/translations/i18n'
import {ChangeEventHandler} from 'react'
import {FieldError} from 'react-hook-form'

interface LegalProtectionRadioButtonsProps {
    name: string
    value: 'subjectTo' | 'notSubjectTo'
    label: string
    onChange: ChangeEventHandler<HTMLInputElement>
    error?: FieldError
}

export const LegalProtectionRadioButtons = ({
    name,
    value,
    label,
    onChange,
    error
}: LegalProtectionRadioButtonsProps) => {
    const {t} = useTranslation()
    return (
        <Flexbox direction="column" gap={1.5} fullWidth>
            <Label>{label}</Label>
            <Flexbox fullWidth direction="column" gap={1.5}>
                <Grid columns={2} gap={4} fullWidth>
                    <FormFieldBox spanColumn={1} isSelected={value == 'subjectTo'} hasError={!!error}>
                        <RadioField
                            label={t('patients:subject_to')}
                            name={name}
                            checked={value == 'subjectTo'}
                            onChange={onChange}
                            value="subjectTo"
                        />
                    </FormFieldBox>
                    <FormFieldBox spanColumn={1} isSelected={value == 'notSubjectTo'} hasError={!!error}>
                        <RadioField
                            label={t('patients:not_subject_to')}
                            name={name}
                            checked={value == 'notSubjectTo'}
                            onChange={onChange}
                            value="notSubjectTo"
                        />
                    </FormFieldBox>
                </Grid>
                {error?.message && <InputHelpText error={error.message} />}
            </Flexbox>
        </Flexbox>
    )
}
